<template>
	<h3>{{ article.title }}</h3>
	<h4 class="d-none d-lg-block">{{ article.author }}</h4>
	<h5 class="d-none d-lg-block">
		{{
			new Date(article.date).toLocaleDateString(undefined, {
				month: "long",
				year: "numeric",
				day: "numeric",
			})
		}}
	</h5>
	<p v-if="excerpt" class="d-none d-md-block">
		{{ article.excerpt }}
	</p>
</template>
<script setup>
const props = defineProps({ article: Object, excerpt: Boolean });
</script>
